import { Popover } from '@mui/material';

import { RenameAppForm } from './RenameAppForm';

interface RenameAppPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  moduleId: string;
}

export const RenameAppPopover = ({
  open,
  anchorEl,
  onClose,
  moduleId,
}: RenameAppPopoverProps) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    classes={{
      paper:
        'min-w-[280px] p-4 shadow-popover-050 border border-solid border-gray-150',
    }}
  >
    <RenameAppForm moduleId={moduleId} onClose={onClose} />
  </Popover>
);
